import React, { useState } from 'react';

const ContactSubmitForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        msg: ''
    });

    const [message, setMessage] = useState({ text: '', isVisible: false });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };
    var btnClicked = false;
    const contactSubmit = async (e) => {
        e.preventDefault();
        btnClicked = true;
        const { name, email, msg } = formData;

        const data = new FormData();
        data.append('nm', name);
        data.append('em', email);
        data.append('msg', msg);

        try {
            const response = await fetch('https://www.adzguruexports.com/contact.php', {
                method: 'POST',
                body: data
            });

            const result = await response.text();

            if (result === 'ok') {
                setMessage({ text: 'Submitted Successfully', isVisible: true });
            } else {
                setMessage({ text: 'Something went wrong! Please try again later.', isVisible: true });
            }

            // Optionally, reset the form
            setFormData({
                name: '',
                email: '',
                msg: ''
            });

        } catch (error) {
            console.error('Error:', error);
            setMessage({ text: 'Error occurred! Please try again later.', isVisible: true });
        }

        // Hide message after 5 seconds
        setTimeout(() => {
            setMessage({ text: '', isVisible: false });
        }, 5000);
    };

    return (
        <form onSubmit={contactSubmit}>
            <div className="row">
                <div className="col-lg-6 col-xl-6 col-md-12">
                    <div className="name_field">
                        <label htmlFor="contact_name">Name</label>
                        <input
                            type="text"
                            id="contact_name"
                            name="name"
                            placeholder="Your Name*"
                            required
                            className="form-control name-control name_text"
                            value={formData.name}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-12">
                    <div className="name_field">
                        <label htmlFor="contact_email">Email</label>
                        <input
                            type="email"
                            id="contact_email"
                            className="form-control name_text name-control"
                            name="email"
                            placeholder="Your Email*"
                            required
                            value={formData.email}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-lg-12 col-xl-12 col-md-12 mt-3">
                    <div className="name_field">
                        {/* <label htmlFor="contact_msg">Message</label> */}
                        <textarea 
                            rows="6" 
                            placeholder="Your Message" 
                            id="contact_message" 
                            className="form_text_area form-control"
                            name="msg"
                            required
                            value={formData.msg}
                            onChange={handleChange}
                            >
                        </textarea>
                    </div>
                </div>
                <div className="col-lg-12 mt-3">
                    {/* <button type="submit" className="submit_button consult_submit submit_button_form1" variant="primary">Submit now</button> */}
                    <div className="submit_but">
                        <button type="submit" className="submit_button_form1 btn btn-primary">Send Message</button>
                    </div>
                </div>
                {((btnClicked) && (!message.isVisible)) && (
                    <div className="col-lg-12">
                        <div className="alert alert-info" role="alert">
                            Loading...
                        </div>
                    </div>
                )}
                {message.isVisible && (
                    <div className="col-lg-12">
                        <p className="alert alert-info">
                            {message.text}
                        </p>
                    </div>
                )}
            </div>
        </form>
    );
};

export default ContactSubmitForm;
